import { memo } from 'react'
import LoadingSkeleton from 'common-components/LoadingSkeleton'
import * as Styled from './styled'

const DropdownSkeleton: React.FC = () => {
  return (
    <Styled.DropdownSkeleton>
      <LoadingSkeleton />
    </Styled.DropdownSkeleton>
  )
}

export default memo(DropdownSkeleton)
